export default {

    methods: {

        validateForms(forms) {
            const errors = [];
            let prevField = null;

            forms.forEach((form) => {
                if (this.$refs[form]) {
                    this.$refs[form].$children.forEach((inputField) => {
                        Object.keys(inputField.$refs).forEach((fieldKey) => {
                            const field = inputField.$refs[fieldKey];

                            if (!field || !field.validate) return;

                            if (!field.validate(true)) {
                                if (typeof field.errorBucket === 'undefined') return;

                                errors.push({
                                    title: field.errorBucket[0],
                                    message: field.errorBucket[1],
                                    location: prevField === null ? fieldKey : prevField,
                                });
                            }
                            prevField = fieldKey;
                        });
                    });
                }
            });
            return errors;
        },
    },

};
